type SceneFrame = {
  width: number
  height: number
}

const DEFAULT_SCENE_FRAME: SceneFrame = {
  width: 1920,
  height: 1080,
}

export const resolveSceneFrame = (scene: any, fallback?: Partial<SceneFrame>): SceneFrame => {
  const backgroundLayer = scene?.layers?.find((layer: any) => layer?.type === "Background")

  const width =
    Number(backgroundLayer?.width || 0) ||
    Number(fallback?.width || 0) ||
    Number(scene?.frame?.width || 0) ||
    DEFAULT_SCENE_FRAME.width

  const height =
    Number(backgroundLayer?.height || 0) ||
    Number(fallback?.height || 0) ||
    Number(scene?.frame?.height || 0) ||
    DEFAULT_SCENE_FRAME.height

  return { width, height }
}
